export default __webpack_public_path__ + "static/media/Shovel of the Dark Messenger.8d26e2c5.jpg";